import {
  CoreFlightsCfarExerciseComponents,
  CORE_FLIGHTS_CFAR_NAME,
} from "@b2bportal/core-types";

import { default as AirCfarExerciseComplete } from "./AirCfarExerciseComplete.module.scss";
import { default as AirCfarExerciseConfirmCancellation } from "./AirCfarExerciseConfirmCancellation.module.scss";
import { default as AirCfarExerciseErrorExercised } from "./AirCfarExerciseErrorExercised.module.scss";
import { default as AirCfarExerciseErrorExpired } from "./AirCfarExerciseErrorExpired.module.scss";
import { default as AirCfarExerciseErrorUnknown } from "./AirCfarExerciseErrorUnknown.module.scss";
import { default as AirCfarExerciseErrorVoid } from "./AirCfarExerciseErrorVoid.module.scss";
import { default as AirCfarExercisePage } from "./AirCfarExercisePage.module.scss";

export const CORE_FLIGHTS_CFAR_EXERCISE_STYLE_OVERRIDES = {
  [CORE_FLIGHTS_CFAR_NAME]: {
    [CoreFlightsCfarExerciseComponents.AirCfarExercisePage]:
      AirCfarExercisePage,
    [CoreFlightsCfarExerciseComponents.AirCfarExerciseConfirmCancellation]:
      AirCfarExerciseConfirmCancellation,
    [CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorVoid]:
      AirCfarExerciseErrorVoid,
    [CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorExpired]:
      AirCfarExerciseErrorExpired,
    [CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorExercised]:
      AirCfarExerciseErrorExercised,
    [CoreFlightsCfarExerciseComponents.AirCfarExerciseComplete]:
      AirCfarExerciseComplete,
    [CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorUnknown]:
      AirCfarExerciseErrorUnknown,
  },
};
